import { render, staticRenderFns } from "./Block5Item.vue?vue&type=template&id=dc0d5dc4&scoped=true&"
import script from "./Block5Item.vue?vue&type=script&lang=js&"
export * from "./Block5Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0d5dc4",
  null
  
)

export default component.exports